import { AfterViewInit, Component, Input, OnChanges, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { RecipientService } from 'src/app/services/recipient.service';
import { SharerService } from 'src/app/services/sharer.service';
import { TaskService } from 'src/app/services/task.service';
import { UserMasterService } from 'src/app/services/user-master.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-recipient-user-list',
  templateUrl: './recipient-user-list.component.html',
  styleUrls: ['./recipient-user-list.component.css']
})
export class RecipientUserListComponent implements OnInit, OnChanges, AfterViewInit {

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtSharerList: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();


  @ViewChild(DataTableDirective)
  dtSharerListForUPSI: DataTables.Settings = {};
  dtOptionsForUPSI: DataTables.Settings = {};
  dtTriggerForUPSI: Subject<any> = new Subject();


  @Input('typeOfUserList') typeOfUserList: any;
  @Input('recipientArray') recipientArray: any;
  selectedUser: any;
  errorMessage: boolean;
  selectedUserArray: any = [];
  internalUser: any = [];
  selectedUserAll: boolean = false;
  selectUPSIUserAll: boolean = false;
  UPSIUserList: any = [];
  BothCombArrayUser: any;
  fileNameArray:any = [];

  constructor(private taskService: TaskService, private sharesrService: SharerService, 
    public activeModal: NgbActiveModal, private renderer: Renderer2, private recipientService: RecipientService, private userMasterService: UserMasterService) { }

  private rerenderTable(): void {
    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTriggerForUPSI.next();
      });
    } else {
      this.dtTriggerForUPSI.next();
    }
  }

  ngOnInit() {
    this.errorMessage = false;
    this.dtOptionsForUPSI = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: false,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      dom: 'lfrtip',
      order: [0, 'asc'],
      columnDefs: [{ orderable: false, targets: [0] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
    }
    // Decide which dataset(s) to load based on selection passed in
    const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));
    const paramData2 = { companyID: companyDetails?.companyID };

    const loadInternalUsers = () => new Promise<void>((resolve) => {
      // Use UserMasterService to get all users including unauthorized ones
      this.userMasterService.getAllUserList().subscribe(response => {
        // Include all users regardless of authorization status (both authorized and unauthorized)
        let cloneOfUserList = Object.assign([], response.result || [])
        // Explicitly ensure we include all users - no filtering by IsAuthorize
        let allUsers = cloneOfUserList.filter(function(user) {
          return user != null && user != undefined;
        });
        let self = this;
        for (let index = 0; index < allUsers.length; index++) {
          let isRecipientFound = _.find(self.recipientArray, function (element) { return element._id == allUsers[index]._id })
          if (_.size(isRecipientFound)) {
            allUsers[index].IsSelected = true
          } else {
            allUsers[index].IsSelected = false
          }
        }
        this.selectedUserAll = (_.size(this.recipientArray) == _.size(allUsers));
        var cloneOfUserListArray = allUsers.map(function (element) {
          var o = Object.assign({}, element);
          o._id = o._id;
          o.Name = o.Title + ' ' + o.FirstName + ' ' + o.LastName;
          o.email_id = o.EmailId;
          o.UserType = 'govevaUser';
          o.IsSelected = o.IsSelected;
          o.Designation = o.Designation;
          o.ContactNumber  = o.MobileNumber;
          return o;
        });
        this.internalUser = cloneOfUserListArray;
        resolve();
      })
    });

    const loadNonGovevaUsers = () => new Promise<void>((resolve) => {
      this.recipientService.getRecipientList(paramData2).subscribe((response:any) => {
        let cloneUPSIUser = Object.assign([], response.data)
        let self = this;
        for (let index1 = 0; index1 < _.size(cloneUPSIUser); index1++) {
          let isUPSIUserFound = _.find(self.recipientArray, function (element) { return element._id == cloneUPSIUser[index1]._id })
          cloneUPSIUser[index1].IsSelected = _.size(isUPSIUserFound) ? true : false;
        }
        this.selectUPSIUserAll = (_.size(cloneUPSIUser) == _.size(this.recipientArray));
        var cloneOfUserListArrayUpsi = cloneUPSIUser.map(function (element) {
          var o = Object.assign({}, element);
          o.UserType = 'nonGovevaUser';
          return o;
        });
        this.UPSIUserList = cloneOfUserListArrayUpsi;
        resolve();
      })
    });

    if (this.typeOfUserList === 'govevaUser') {
      loadInternalUsers().then(() => {
        this.BothCombArrayUser = this.internalUser;
        this.rerenderTable();
      })
    } else if (this.typeOfUserList === 'nonGovevaUser') {
      loadNonGovevaUsers().then(() => {
        this.BothCombArrayUser = this.UPSIUserList;
        this.rerenderTable();
      })
    } else {
      // Fallback: load both like before
      Promise.all([loadInternalUsers(), loadNonGovevaUsers()]).then(() => {
        this.BothCombArrayUser = (this.internalUser || []).concat(this.UPSIUserList || []);
        this.rerenderTable();
      })
    }
  }

  ngOnChanges() {

  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("select_user")) {
        if (_.size(this.selectedUserArray)) {
          if (event.target.checked) {
            this.selectedUserArray.push(event.target.attributes.select_user.value)
          } else {
            let indexOfuser = _.findIndex(this.selectedUserArray, function (element) { return element == event.target.attributes.select_user.value })
            this.selectedUserArray.splice(indexOfuser, 1)
          }
        } else {
          this.selectedUserArray.push(event.target.attributes.select_user.value)
        }
        this.errorMessage = false
      }
      if (event.target.hasAttribute("select_all")) {
        console.log('it is clicked')
        this.selectAll(event)
      }
    });
  }


  selectedSharerUser(userDetail) {
    console.log(userDetail)
  }

  save() {
    this.selectedUserArray = _.map(_.filter(this.BothCombArrayUser, function (element) { return element.IsSelected == true }), function (object) { return object })
    if (_.size(this.selectedUserArray)) {
      this.activeModal.close(this.selectedUserArray)
    } else {
      this.errorMessage = true;
    }
  }

  cancel() {
    this.activeModal.dismiss('dismiss')
  }


  multiCheck($event, id, index) {
    console.log(event)
    this.BothCombArrayUser[index].IsSelected = $event.target.checked
    console.log(_.filter(this.BothCombArrayUser, ['IsSelected', true]))
  }

  selectAll($event) {
    const checked = $event?.target?.checked === true;
    // Simply toggle selection for the current visible dataset without mutating it
    (this.BothCombArrayUser || []).forEach(item => {
      item.IsSelected = checked;
    });
    this.selectUPSIUserAll = checked;
  }
}
